import { AuthenticateWithRedirectCallback } from "@clerk/clerk-react";

export const SSOCallbackPage = () => {
    return (
        <AuthenticateWithRedirectCallback
            signUpUrl="/sign-in?error=no-account"
            signUpForceRedirectUrl="/sign-in?error=no-account"
        />
    );
};
